import twclsx from 'utils/twclsx';

function EBTCardLast4({ as = 'span', className, last4, maskFull = false }) {
    const As = as;

    return (
        <As className={twclsx('text-body-md', className)} data-testid="ebt-card-last4">
            EBT Card <span className="whitespace-nowrap">{maskFull ? `**** **** **** ${last4}` : `*${last4}`}</span>
        </As>
    );
}

export { EBTCardLast4 };
